export default __webpack_public_path__ + "static/media/web.57e9fc14.svg";